import React, { useEffect } from 'react';

import { Typography, Box, Divider } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { useAppDispatch, useAppSelector } from 'hooks';
import { alertsActions } from 'state/alerts';

import StandardPage from 'components/StandardPage';
import { useParams } from 'react-router-dom';
import AlertOverview from 'components/alerts/Overview';

interface Props {}

const SingleAlertPage: React.FunctionComponent<Props> = ({}) => {
    const theme = useTheme();

    const { alertId } = useParams();
    const id = Number(alertId);
    const dispatch = useAppDispatch();
    const { alertDetails, alertAckResponse } = useAppSelector(
        (root) => root.alerts,
    );

    const { auth } = useAppSelector((state) => state);

    const alert = alertDetails.object;

    const getAlert = () => {
        dispatch(alertsActions.getAlert({ id: id }));
    };

    //gets Alert when page is initially loaded
    useEffect(() => {
        if (
            auth.tokens.status === 'finished' &&
            alertDetails.status === 'idle' &&
            alertId
        ) {
            getAlert();
        }
    }, [alertDetails.status, auth.tokens]);

    //updates alert when URL id changes
    useEffect(() => {
        if (alertId && alertDetails.status !== 'idle') {
            getAlert();
        }
    }, [alertId]);

    //update when acknowledge status changes
    useEffect(() => {
        if (alertAckResponse.status === 'finished' && alertId) {
            getAlert();
        }
    }, [alertAckResponse.status]);

    const makeAlertTypeNamePretty = (type: string) => {
        return type
            .split('_')
            .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
            .join(' ');
    };

    return (
        <StandardPage
            title="Alerts Detail"
            breadcrumbs={[
                { text: 'Home', link: '/' },
                { text: 'Alerts', link: '/alerts' },
                { text: 'Alerts Detail' },
            ]}
            maxWidth="xl"
        >
            {alert && (
                <Box
                    sx={{
                        backgroundColor: theme.palette.common.neutralXXLight,
                        borderRadius: 1,
                        p: 1,
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            gap: 1,
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}
                    >
                        <Typography variant="h4">
                            {makeAlertTypeNamePretty(alert.type)} (Id: {alertId}
                            )
                        </Typography>
                    </Box>
                    <Box
                        sx={{
                            display: 'grid',
                            gridTemplate: '1fr 1fr / auto auto',
                        }}
                    >
                        <AlertOverview alert={alert} />
                    </Box>
                    <Divider sx={{ my: 1 }} />
                    <Box
                        sx={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr',
                            gap: 2,
                        }}
                    ></Box>
                </Box>
            )}
        </StandardPage>
    );
};

SingleAlertPage.displayName = 'SingleAlertPage';
export default SingleAlertPage;
